import { render, staticRenderFns } from "./examRoomPlan.vue?vue&type=template&id=9ffd13ae&"
import script from "./examRoomPlan.vue?vue&type=script&lang=js&"
export * from "./examRoomPlan.vue?vue&type=script&lang=js&"
import style0 from "./examRoomPlan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports